export default {
  parameters: {
    landing_id: "TRMathAB",
  },
  downtimeUrl: "https://math.kodland.tech",
  // hookId: "0m86yo9ehsfcln66536g4vktw62jd7ed",
  startPage: {
    image: "/welcome/quiz_turkey_math.jpeg",
    imageMobile: "/welcome/quiz_turkey_math_mobile.png",
    title: "2 dakikalık bir anketi tamamlayarak ÜCRETSİZ matematik dersi alın ",
    titleSecondLine:
      "Çocuğunuzun temel matematik seviyesini belirleyeceğiz ve onu geliştirmek için bir plan hazırlayacağız.",
    subtitle: "Çocuğunuz için ücretsiz çevrimiçi matematik dersi.",
    button: "Haydi başlayalım!  🚀",
  },
  successPage: {
    title: "Ücretsiz dersinizi almak için tarih belirleyin",
    subtitle: "📆 Hemen Kaydol butonuna tıklayarak rezervasyonu tamamlayabilirsiniz.",
    button: "📆 Hemen Kaydol",
  },
  quizRotateBySteps: {
    1: {
      question: "Çocuğunuzun matematik ortalaması nedir?",
      answers: ["0-45", "45-54", "55-69", "70-84", "85-100"],
    },
    2: {
      question: "Çocuğunuz matematik öğrenirken ne gibi zorluklar yaşıyor?",
      answers: [
        "😥 Çocuk matematiği sevmiyor",
        "😪 Okulda kötü notlar",
        "🙂 Bazı konuları anlamıyor",
        "😍 Zorluk yok",
      ],
    },
    3: {
      question:
        "Çocuğunuzun Matematik bilgisiyle ilgili sizi en çok kaygılandıran konular hangileridir?",
      answers: [
        "🏆 LGS Sınavı",
        "🎓 Okul notları",
        "➖ Bilgi açığı",
        "😔 Çalışmak için motivasyon eksikliği",
      ],
    },
    4: {
      question: "Ekstra Matematik dersleri alıyor musunuz?",
      answers: ["👍 Evet", "⛔️ Hayır"],
    },
    5: {
      question: "Nasıl çalışıyorsunuz?",
      answers: [
        "🏢 Eğitim merkezi",
        "👨‍🏫 Özel öğretmen",
        "🌐 Online dersler",
        "🎓 Etüt dersleri",
        "📚 Bireysel çalışma",
        "⛔️ Ekstra ders almıyorum",
      ],
    },
    6: {
      question: "Sizin için bu derslerdeki en önemli unsur nedir?",
      answers: [
        "🧠 Öğrenim kalitesi",
        "👨‍🏫 Bireysel yaklaşım",
        "💰 Fiyat/Kalite oranı",
        "🌐 Tavsiyeler",
        "⛔️ Ekstra ders almıyorum",
      ],
    },
    7: {
      question: "Ücretsiz deneme dersinizden beklediğiniz en önemli kazanımlar nelerdir?",
      answers: [
        "😌 Çocuğun mevcut seviyesini öğrenin",
        "👍 Zorluklarla nasıl başa çıkacağınızı öğrenin",
        "🎓 Çocuğunuzun motivasyonunda bir artış",
        "😎 Kullanıcı dostu öğrenme platformumuz hakkında bilgi",
      ],
    },
    8: {
      question: "Çocuğunuzun okulda en sevdiği ders hangisidir?",
      answers: [
        "🔬 Fen bilimleri",
        "🎨 Sanat ve tasarım",
        "💻 Bilgisayar bilimi",
        "📙 Tarih, Edebiyat",
        "🗣 Yabancı diller",
        "➗ Matematik",
        "❤️ Tüm dersler",
        "🤔 Emin değilim",
      ],
    },
    9: {
      question:
        "Deneme sınıfı için kullanabileceğiniz bir bilgisayarınız/diazüstü bilgisayarınız/tabletiniz var mı?",
      answers: ["💻 Evet", "🙁 Hayır"],
    },
  },
};
